import SectionHeading from "@/components/base/SectionHeading";
import { submitSteps } from "@/mocks/posts";

export default function SubmitGuide() {
  return (
    <section id="submit" className="mx-auto w-full max-w-container scroll-mt-24 px-4 md:px-6 py-16 md:py-20">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="p-8 md:p-12 lg:col-span-7">
            <SectionHeading
              eyebrow="Contribute"
              title="投稿一条线索，只要三步"
              desc="不需要华丽的文笔，把事情说清楚就够了。你的每一条分享，都可能成为别人理解世界的入口。"
            />

            <ol className="mt-9 flex flex-col gap-6">
              {submitSteps.map((item) => (
                <li key={item.step} className="flex items-start gap-4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                    <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                  </span>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-label text-xs font-semibold tracking-widest text-primary-600">{item.step}</span>
                      <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.title}</h3>
                    </div>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-9 flex flex-wrap items-center gap-3">
              <a
                href="#feed"
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-quill-pen-line text-base" aria-hidden="true" />
                开始投稿
              </a>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer whitespace-nowrap"
              >
                先看看投稿规则
                <i className="ri-arrow-right-line text-base" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="relative min-h-[280px] lg:col-span-5">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20a%20notebook%20pen%20and%20cup%20of%20tea%20on%20a%20wooden%20desk%20by%20a%20window%2C%20coral%20and%20amber%20tones%2C%20soft%20natural%20light%2C%20no%20text&width=800&height=900&seq=kanliao-submit-01&orientation=portrait"
              alt="在窗边写下一条线索的温暖场景"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}